module.exports = __webpack_public_path__ + "img/olympic-hockey.d7da50c6.png";